export enum DeLeePlan {
	Detachment = "0",
	Vulva = "1",
	Three = "2",
	Two = "3",
	One = "4",
	Zero = "5",
	MinusOne = "6",
	MinusTwo = "7",
	MinusThree = "8",
}

export const DeLeePlanMessages = {
	[DeLeePlan.Detachment]: "Desp.",
	[DeLeePlan.Vulva]: "Vulva",
	[DeLeePlan.Three]: "3",
	[DeLeePlan.Two]: "2",
	[DeLeePlan.One]: "1",
	[DeLeePlan.Zero]: "0",
	[DeLeePlan.MinusOne]: "-1",
	[DeLeePlan.MinusTwo]: "-2",
	[DeLeePlan.MinusThree]: "-3",
};
